import { cleanTrashMutation, type StoragePoolWithType } from "@/admin/buckets/storagePoolsQuery.ts";
import { WModal, WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { ReactNode } from "react";

interface CleanTrashModalProps {
    item: StoragePoolWithType;
    location: string;
    button: ReactNode;
}

export function CleanTrashButton(props: CleanTrashModalProps) {
    return (
        <WModal button={props.button}>
            <CleanTrashModalContent {...props} />
        </WModal>
    );
}

function CleanTrashModalContent({ item, location }: CleanTrashModalProps) {
    const cleanMutation = useStandardMutation(cleanTrashMutation);

    async function cleanTrash() {
        await cleanMutation.mutateAsync({ uuid: item.uuid, location });
    }

    return (
        <WModalContent title="Clean trash" label="Clean" modalAction={cleanTrash}>
            This will forcefully purge all disk images currently held in the trash area
            <br /> of storage pool "<b>{item?.display_name}</b>", ignoring all expiry dates.
        </WModalContent>
    );
}
